export const AUTH_TOKEN = 'PERSONAL_AUTH_TOKEN';
export const IS_LOGGED = 'PERSONAL_IS_LOGGED';
export const AUTH_USER = 'AUTH_USER';
